import React from "react";
import { HRProvider } from "../HRContext";
import EmployeeList from "../employees/EmployeeList";

const EmployeeListWrapper: React.FC = () => {
  return (
    <HRProvider>
      <EmployeeList />
    </HRProvider>
  );
};

export default EmployeeListWrapper;
